import React from "react";
import style from "./ReadOnlyBanner.module.scss";

export const InfoBanner = ({ message, children }) => {
  return (
    <div className={style.info_banner}>
      <div className={`alert alert-info ${style.info_banner_content}`}>
        <i className="fa fa-info-circle" aria-hidden="true" />
        <div>{children || message}</div>
      </div>
    </div>
  );
};
